// src/context/errors/ErrorProvider.js
import React, { createContext, useContext, useState } from 'react';
import { registerShowError } from './globalShowError';

const ErrorContext = createContext();

export const ErrorProvider = ({ children }) => {
  const [errors, setErrors] = useState([]); // Массив ошибок

  const showError = (error) => {
    setErrors((prev) => [...prev, error]);
  };

  const clearError = (index) => {
    setErrors((prev) => prev.filter((_, i) => i !== index));
  };

  // Регистрируем глобальный обработчик при монтировании
  registerShowError(showError);

  return (
    <ErrorContext.Provider value={{ errors, showError, clearError }}>
      {children}
    </ErrorContext.Provider>
  );
};

export const useError = () => useContext(ErrorContext);


/*
export const ErrorProvider = ({ children }) => {
  const [error, setError] = useState(null); // { message, retry }

  const showError = (error) => setError(error);
  const clearError = () => setError(null);

  
  registerShowError(showError);

  return (
    <ErrorContext.Provider value={{ error, showError, clearError }}>
      {children}
    </ErrorContext.Provider>
  );
};
*/